module.exports = __webpack_public_path__ + "img/NukedTV-Web_17.561f5fd1.png";